import Vue from 'vue'
import VueI18n from 'vue-i18n'
import merge from 'lodash/merge'

const defLang = 'sv'
const langs = [
  {value: 'sv', text: 'Svenska' }, 
  {value: 'en', text: 'English' },
]

let messages = {}

//- Loadup messages
langs.forEach(lang => {
  let jsonfile = require('./lang/' + lang.value + '.json')
  let vuetifylang = process.env.NODE_ENV === "test" ? {} : require(`vuetify/lib/locale/${lang.value}.js`)

  merge(messages, {[lang.value]: jsonfile})
  merge(messages, {[lang.value]: {'$vuetify': vuetifylang.default } })
})

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: defLang,
  messages
})

export default i18n
export const Languages = langs
export const DefaultLanguage = defLang
